import { vShow as _vShow, vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-46b7adc6")

_pushScopeId("data-v-46b7adc6")
const _hoisted_1 = { class: "w-full inline-block relative bottom-0 left-0 text-12px xxl:text-14px" }
const _hoisted_2 = { class: "inline-block relative w-full z-10" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  class: "w-4",
  alt: "up"
}
const _hoisted_4 = {
  key: 0,
  class: "text-red-lp-400 w-full flex flex-row justify-end mb-2 pr-3"
}
const _hoisted_5 = {
  key: 1,
  class: "p-2"
}
const _hoisted_6 = {
  key: 2,
  class: "py-4 mb-2 text-gray-lp-300 text-center items-center"
}
const _hoisted_7 = { class: "w-4 mr-3" }
const _hoisted_8 = {
  key: 0,
  class: "w-4",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("path", {
  fill: "#B82025",
  d: "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
}, null, -1)
const _hoisted_10 = {
  key: 1,
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("g", { opacity: "0.5" }, [
  /*#__PURE__*/_createVNode("rect", {
    x: "0.5",
    y: "1",
    width: "15",
    height: "15",
    rx: "2.5",
    fill: "#A7A8AA",
    stroke: "#E0E0E0"
  })
], -1)
const _hoisted_12 = {
  key: 2,
  class: "w-4",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("path", {
  fill: "#e0e0e0",
  d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
}, null, -1)
const _hoisted_14 = { class: "w-auto" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "flex pt-2" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "items-center w-full flex flex-wrap" }
const _hoisted_20 = {
  key: 1,
  class: "items-center w-full flex flex-wrap"
}
const _hoisted_21 = { class: "flex flex-row bg-gray-lp-1300 rounded px-1 py-0.5 mr-1 mb-2 whitespace-no-wrap" }
const _hoisted_22 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z",
  fill: "#ABACAE"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Icons = _resolveComponent("Icons")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.hideInput)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: 
        `w-full ${
          _ctx.isOpenMenu && !_ctx.isDisabled
            ? 'border-l border-t border-r rounded-t'
            : !_ctx.modelValue.length
            ? 'border rounded-md'
            : 'border rounded-t-md'
        } ${
          _ctx.error ? 'border-red-lp-100' : 'border-gray-lp-400'
        } text-black-lp-300`
      ,
          style: `${_ctx.disableBackground ? 'background-color: #F0F0F0' : ''}`
        }, [
          _createVNode("div", _hoisted_2, [
            _withDirectives(_createVNode("input", {
              style: 
            `padding-top: 11px; padding-bottom: 11px; ${
              _ctx.disableBackground ? 'background-color: #F0F0F0' : ''
            }`
          ,
              class: 
            `w-full truncate cursor-pointer bg-white rounded-md leading-tight px-3 text-12px xxl:text-14px pr-8 font-normal focus:outline-none ${
              _ctx.isDisabled
                ? 'text-gray-lp-600 cursor-not-allowed'
                : 'text-black-lp-300 cursor-pointer'
            }`
          ,
              disabled: _ctx.isDisabled,
              autocomplete: "nope",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedItemsName = $event)),
              onFocus: _cache[2] || (_cache[2] = 
            () => {
              if (!_ctx.isDisabled) {
                _ctx.onOpenSelect(true);
                _ctx.$refs.selectSearch.focus();
              }
            }
          )
            }, null, 46, ["disabled"]), [
              [_vShow, _ctx.modelValue.length > 0 && _ctx.showSelectedInInput && !_ctx.isOpenMenu],
              [_vModelText, _ctx.selectedItemsName]
            ]),
            _withDirectives(_createVNode("input", {
              style: [{"padding-top":"11px","padding-bottom":"11px"}, 
            `${
              !_ctx.modelValue.length
                ? 'border-top-left-radius:0.375rem; border-top-right-radius:0.375rem;'
                : 'border-top-left-radius:0.75rem; border-top-right-radius:0.75rem;'
            } ${_ctx.disableBackground ? 'background-color: #F0F0F0' : ''}`
          ],
              ref: "selectSearch",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterSearch = $event)),
              onFocus: _cache[4] || (_cache[4] = () => (!_ctx.isDisabled ? _ctx.onOpenSelect(true) : {})),
              onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args))),
              placeholder: _ctx.placeholder,
              class: 
            `w-full bg-white ${
              !_ctx.modelValue.length ? 'rounded-md' : 'rounded-t-md'
            } leading-tight px-3 text-12px xxl:text-14px pr-8 font-normal focus:outline-none ${
              _ctx.isDisabled
                ? 'text-gray-lp-600 cursor-not-allowed'
                : 'text-black-lp-300 cursor-pointer'
            }`
          ,
              disabled: _ctx.isDisabled,
              autocomplete: "nope",
              readonly: _ctx.isSearchReadonly
            }, null, 46, ["placeholder", "disabled", "readonly"]), [
              [_vShow, 
            _ctx.showSelectedInInput ? _ctx.modelValue.length === 0 || _ctx.isOpenMenu : true
          ],
              [_vModelText, _ctx.filterSearch]
            ]),
            _withDirectives(_createVNode("div", {
              class: "cursor-pointer absolute inset-y-0 right-0 flex items-center px-2",
              onClick: _cache[7] || (_cache[7] = 
            () =>
              _ctx.isOpenMenu ? _ctx.onOpenSelect(false) : _ctx.$refs.selectSearch.focus()
          )
            }, [
              (_ctx.isOpenMenu)
                ? (_openBlock(), _createBlock("img", _hoisted_3))
                : (_openBlock(), _createBlock("img", {
                    key: 1,
                    src: _imports_1,
                    class: "w-4",
                    onClick: _cache[6] || (_cache[6] = () => (_ctx.isChevron = true)),
                    alt: "down"
                  }))
            ], 512), [
              [_vShow, !_ctx.isDisabled]
            ])
          ])
        ], 6))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", {
      class: 
        `w-full bg-white absolute border border-t-0 ${
          _ctx.error ? 'border-red-lp-100' : 'border-gray-lp-400'
        } rounded-b-md z-20`
      
    }, [
      _createVNode("div", {
        onScrollend: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fetchNew && _ctx.fetchNew(...args)), ["prevent"])),
        class: "overflow-y-auto scroll border-t pt-2",
        style: {"max-height":"155px"}
      }, [
        (_ctx.dataOptions.length > 0 && !_ctx.isLoading && _ctx.showReset)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("span", {
                class: "cursor-pointer",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
              }, "reset")
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode("div", { class: "text-red-lp-100 text-12px xxl:text-14px p-2" }, _toDisplayString(_ctx.errorCaption), 513), [
          [_vShow, _ctx.error]
        ]),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode(_component_Skeleton, {
                height: "1.3rem",
                width: "60%",
                class: "my-2"
              }),
              _createVNode(_component_Skeleton, {
                height: "1.3rem",
                width: "80%",
                class: "my-2"
              }),
              _createVNode(_component_Skeleton, {
                height: "1.3rem",
                width: "40%",
                class: "my-2"
              }),
              _createVNode(_component_Skeleton, {
                height: "1.3rem",
                width: "70%",
                class: "my-2"
              })
            ]))
          : (_ctx.dataOptions.length === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("notification.emptyNoResultDescription")), 1))
            : (_openBlock(true), _createBlock(_Fragment, { key: 3 }, _renderList(_ctx.dataOptions, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index,
                  class: index === _ctx.dataOptions.length - 1 && 'pb-2'
                }, [
                  _createVNode("div", {
                    class: 
              `w-full cursor-pointer flex flex-row items-center px-4 py-1 hover:bg-gray-lp-700 ${index ===
                _ctx.dataOptions.length - 1 && 'pb-2'} ${
                _ctx.isSelected(item) ? 'text-red-lp-100' : _ctx.disabledBosspack && item.toLowerCase().includes('bosspack') ? 'text-gray-lp-600 cursor-not-allowed' : 'text-black-lp-200'
              }`
            ,
                    onClick: ($event: any) => (_ctx.disabledBosspack && item.toLowerCase().includes('bosspack') ? '' : _ctx.onChooseSelect(item, index))
                  }, [
                    _createVNode("div", _hoisted_7, [
                      (_ctx.isSelected(item))
                        ? (_openBlock(), _createBlock("svg", _hoisted_8, [
                            _hoisted_9
                          ]))
                        : (_ctx.disabledBosspack && item.toLowerCase().includes('bosspack'))
                          ? (_openBlock(), _createBlock("svg", _hoisted_10, [
                              _hoisted_11
                            ]))
                          : (_openBlock(), _createBlock("svg", _hoisted_12, [
                              _hoisted_13
                            ]))
                    ]),
                    _createVNode("div", _hoisted_14, [
                      (String(item[_ctx.keyValue])?.toLowerCase() === 'all')
                        ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.customDisplayAll), 1))
                        : (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(_ctx.noteForBosspack && (item[_ctx.keyName] || item) === 'BOSSPACK' ? _ctx.$t("bosspackNote") : item[_ctx.keyName] || item), 1))
                    ])
                  ], 10, ["onClick"])
                ], 2))
              }), 128))
      ], 32)
    ], 2), [
      [_vShow, _ctx.isOpenMenu && !_ctx.isDisabled]
    ]),
    (_ctx.modelValue.length > 0 && _ctx.showSelected)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: ["py-1 px-3 text-gray-lp-300 border-b border-l border-r rounded-b-md overflow-y-auto scroll", `${_ctx.isDisabled ? 'bg-gray-lp-1500' : ''}`],
          style: {"max-height":"85px"}
        }, [
          _createVNode("div", _hoisted_17, [
            (!_ctx.isAll())
              ? (_openBlock(), _createBlock("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterShowValue, (item, index) => {
                      return (_openBlock(), _createBlock("div", { key: index }, [
                        _createVNode("div", {
                          class: 
                  `${
                    item.isError
                      ? 'bg-red-lp-1300 text-red-lp-100'
                      : 'bg-gray-lp-1300'
                  } flex flex-row items-center rounded px-1 py-0.5 mr-1 mb-2 whitespace-no-wrap`
                
                        }, [
                          _createTextVNode(_toDisplayString((_ctx.displayValue ? item[_ctx.keyValue] : item[_ctx.keyName]) || item) + " ", 1),
                          (!_ctx.isDisabled)
                            ? (_openBlock(), _createBlock(_component_Icons, {
                                key: 0,
                                onClick: () => (_ctx.isDisabled ? {} : _ctx.onChooseSelect(item, index)),
                                name: "icon-x",
                                class: 
                    `ml-2 w-4 ${
                      item.isError ? 'text-red-lp-100' : 'text-gray-lp-600'
                    } ${!_ctx.isDisabled && 'cursor-pointer'}`
                  
                              }, null, 8, ["onClick", "class"]))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _createTextVNode(_toDisplayString(_ctx.modelValue[0].name || "Semua") + " ", 1),
                    (!_ctx.isDisabled)
                      ? (_openBlock(), _createBlock("svg", {
                          key: 0,
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onChooseAll())),
                          class: "w-4 ml-2 cursor-pointer",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _hoisted_22
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_click_outside, 
      e => {
        if (_ctx.isChevron) {
          _ctx.$refs.selectSearch.focus();
          _ctx.isChevron = false;
        } else if (_ctx.isOpenMenu) {
          e.preventDefault();
          _ctx.onOpenSelect(false);
        }
      }
    ]
  ])
})